import React from 'react'
import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'

import { selectMyPageIds } from './pagesSlice'
import { selectLastPageId } from '../user/userSlice'
import Page from './Page'

// /app/pages names no page, so it goes to one: the page of mine I was on last
// (`last_page_id`, from the server and kept up to date by Page), which for a
// new account is its welcome page. If that one has just been deleted, the
// first of my pages in the list, which the server sends most recently
// accessed first. With no pages at all there is nothing to go to, so the empty
// page shows, with the pages drawer open on its "create a page" form.
//
// `openPagesPane` says whether the page it lands on opens the drawer too:
// asking for /app/pages is asking for the list of pages, while plain /app is
// just "take me back", and an open drawer would only take up room.
export default function LastPage({ openPagesPane = true }) {
  const lastPageId = useSelector(selectLastPageId)
  const myPageIds = useSelector(selectMyPageIds)
  const target = lastPageId || myPageIds[0]

  if (target) {
    return (
      <Navigate to={`/app/pages/${target}`} replace state={{ openPagesPane }} />
    )
  }
  return <Page />
}
